export default {
  administration: 'Spravovať',
  companies: 'Spoločnosti',
  companyAuthorized: 'Domov',
  companyReviews: 'Recenzie',
  dashboard: 'Domov',
  editCompany: 'Upraviť',
  editService: 'Upraviť',
  navigation: 'Navigácia',
  serviceAuthorized: 'Domov',
  calendar: 'Kalendár',
  products: 'Produkty',
  serviceReviews: 'Recenzie',
  services: 'Služby'
}



// WEBPACK FOOTER //
// ./src/i18n/sk/navigation.js